import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { authService } from '../services/authService'

export const useLogin = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { dispatch } = useAuthContext()

  const login = async (email, password, companyId) => {
    try {
      setIsLoading(true)
      setError(null)

      const { response, json } = await authService.login(email, password, companyId)

      if (!response.ok) {
        setIsLoading(false)
        setError(json.error)
      }

      if (response.ok) {
        if (json?.is_terminated) {
          setIsLoading(false)
          setError('Not authorized.')
        } else {
          // save the user to local storage
          localStorage.setItem('user', JSON.stringify(json))

          // update the auth context
          dispatch({ type: 'LOGIN', payload: json })

          // update loading state
          setIsLoading(false)
        }
      }
    } catch (error) {
      console.error(error.message)
    } finally {
      setIsLoading(false)
    }
  }
  return { login, isLoading, error, setError }
}
